<!-- HTML -->
<template>
    <div class="custom-style-header pt10 pb10">
        <div class="custom-style-content flex y-center">
            <div class="flex">
                <div class="header-content-item logo">
                    <router-link v-if="routerName!='Searchseat'" :to="`/${$route.params.meeting_id}`"><img src="~@/assets/images/logo-min.png" alt=""></router-link>
                </div>
                <div class="header-hall ml40 flex y-center">
                    <router-link target="_blank" class="mr10" :to="`/searchseat/${$route.params.meeting_id}`">
                        <a-button type="primary" class="btn-style"><i class="iconfont icon-sousuo-sousuo"></i>查找姓名</a-button>
                    </router-link> 
                    <a-button @click="$emit('exportSeat')">导出座位图</a-button>
                </div>
            </div>
            <div v-if="meetingInfo" class="header-content-item mr25">
                <div class="header-text">
                    <div v-if="hallData" class="fs16 fb"><strong>{{hallData.hall_name}}</strong></div>
                    <div v-if="hallData" class="color999">
                        <span>地址：{{hallData.hall_desc}}</span>
                        <span class="ml20">时间：{{ hallData.hall_date && hallData.hall_date.substr(0,10) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<!-- js脚本 -->
<script>
import { mapState } from 'vuex';
export default {
    props: {},
    data() {
        return {
            hallData: null,
             routerName: '',
        }
    },
    watch: {
        '$route.name': {
            handler() {
                this.hallData = null;
                this.routerName = this.$route.name;
            },
            immediate: true,
        },
    },
    computed:{
        ...mapState(['meetingInfo']),
    },
    methods: {
        // 获取数据
        getHallData() {
            this.$request.post({ url: "getHall" }).then(res => {
                this.hallData = res.data.findItem({ id: this.$route.query.hall_id });
            })
        },
    },
    mounted() {
        this.getHallData();
    }
};
</script>

<!-- css样式 -->
<style lang="less" scoped>
.custom-style-header {
    border-bottom: 1px solid #f5f6f9;
    min-height: 60px; //box-shadow: inset 0 -2px 5px rgba(0,0,0,.1);
    background-color: #fff;
}

// 手机端适配
@media (max-width: 767px) {
    .custom-style-header {
        padding: 15px;
        .custom-style-content {
            display: block;
            img {
                width: 200px;
            }
            .header-hall{
                margin-left:0;
            }
        }
        .max-width {
            margin: 10px auto !important;
        }
        .header-content-item {
            margin-right: 0;
        }
    }
}
</style>